import * as React from 'react'
import { useSelector } from 'react-redux'
import { getModalIsVisible } from './state/modals/selectors'

const Modals = React.lazy(() => import('@src/components/Modals'))

export default function() {
  const isVisible = useSelector(getModalIsVisible)
  return isVisible ? (
    <React.Suspense fallback={null}>
      <Modals />
    </React.Suspense>
  ) : null
}



// WEBPACK FOOTER //
// ./src/Modals.tsx